import { CommonModule } from "@angular/common";
import { Component, OnInit, TemplateRef } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { BehaviorSubject, debounceTime, distinctUntilChanged, map, Subject, Subscription } from "rxjs";
import { CreateteamModelComponent } from "src/app/page/model/createteam-model/createteam-model.component";
import { ApiService } from "src/app/services/api.service";
import { AppSettings } from "src/app/services/AppSettings";
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { JobService } from "src/app/services/job.service";
import { SearchData } from "src/app/services/searchData";
import { UserCardConfig } from "src/app/types/UserCardConfig";
import Swal from "sweetalert2";
import { FilterPipe } from '../../../pipe/SearchFilter/filter.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { WidgetModule } from '../../../widget/widget.module';
import { UserCardComponent } from '../../cards/user-card/user-card.component';
import { UtilService } from "./../../../services/util.service";
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: "app-team-members-page",
  standalone: true,
  imports: [BsDropdownModule, CommonModule, FormsModule, ReactiveFormsModule, CommonSkeletonComponent, UserCardComponent, NodataFoundComponent, FilterPipe, NgSelectModule, WidgetModule, InfiniteScrollModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./team-members-page.component.html",
  styleUrls: ["./team-members-page.component.scss"],
})
export class TeamMembersPageComponent implements OnInit {
  modalRef: BsModalRef;
  pathdata;
  membersForm: UntypedFormGroup;
  conditionList: any = [];
  membersData: any = [];
  conditionSelectedItems: any;
  userCardConfig: UserCardConfig[] = [];
  tempData: any = [];
  ownerFlag = false;
  teamMembersSearch: any;
  url = AppSettings.photoUrl;
  clickEventsubscription: Subscription;
  pesponseDisplay:any;
  loadAPIcall:boolean=false
  noDatafound : Array<string> = ["You have no member"];
  showNoDatafound: boolean = false;
  searchKey
  totalCount: number = 0;
  stopScroll: boolean = false;
  previouseAfterKey: any = null;
  searchSubject = new Subject<string>();
  scrollSubject = new BehaviorSubject<string>(null);
  loadScroll: boolean;
  membersPayload = {
    teamId: null,
    limit: 10,
    searchAfterKey: null,
    searchContent: null,
    status: "ACTIVE",
  }
  // client-side filter key for Admins/Members views; the All view searches server-side
  get searchFilterKey(): string {
    if (this.filterName === 'All' || !this.searchKey) return '';
    const trimmed = this.searchKey.trim();
    return trimmed ? trimmed : '$^'; // whitespace-only input must match nothing
  }
   constructor(
    private route: ActivatedRoute,
    private util: UtilService,
    private fb: UntypedFormBuilder,
    private modalService: BsModalService,
    private api: ApiService,
    private router: Router,
    private commonValues: SearchData,
    // private teamModel: CreateteamModelComponent,  // this component injection has no usage so i commented it
    private JobServicecolor: JobService,
  ) {
    this.clickEventsubscription = commonValues.getTeamdata().subscribe(res => {
      this.pesponseDisplay = res
    })
  }

  ngOnInit() {
    //// this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.queryParams.subscribe((res) => {
      this.pathdata = res;
      if (res.teamId == undefined) {
        this.refresh();
      }
      if (localStorage.getItem("userId") == this.pathdata.teamsOwnerId) {
        this.ownerFlag = true;
        let revokeBtn: UserCardConfig = new UserCardConfig(
          "Revoke",
          this.removeMember,
          this.canShow,
          true
        );
        revokeBtn.source = this;
        this.userCardConfig.push(revokeBtn);
      } else {
        this.ownerFlag = false;
      }
    });

    this.connectedlist();
    this.getMemberList();
    this.formNetworkModal();
    this.membersForm = this.fb.group({
      addconnection: this.pathdata.teamName,
      description: this.pathdata.description,
    });

    this.searchSubject.pipe(
      debounceTime(500),
      map((res: string) => (res || '').trim().replace(/\s+/g, ' ')),
      distinctUntilChanged()
    ).subscribe(res => {
      if (this.filterName !== 'All') { return; } // Admins/Members views filter client-side via searchFilterKey
      if (res === (this.membersPayload.searchContent || '')) { return; } // skip whitespace-only / unchanged searches
      this.loadScroll = false;
      this.resetPayload();
      this.membersPayload.searchContent = res || null;
      this.getMemberList();
    });

    this.scrollSubject.pipe(
      debounceTime(100),
      distinctUntilChanged()
    ).subscribe(res => {
      if (res != null) {
        this.membersPayload.searchAfterKey = this.previouseAfterKey;
        this.getMemberList();
      }
    })
  }
    // for first and last name
    getInitialName(firstname: string,lastname: string): string {
      return this.JobServicecolor.getInitialsparam(firstname,lastname);
    }
     // for first and last name
     getColorName(firstname: string,lastname: string): string {
      return this.JobServicecolor.getColorparam(firstname,lastname);
    }
    getTextColor(firstname: string,lastname: string): string {
      return this.JobServicecolor.getTextColor(firstname,lastname);
    }

  filterName : string = "All";
  allEmployee()
  {
    this.filterName = "All";
    this.loadScroll = false;
    this.resetPayload();
    // carry an active search over to the server-side search of the All view
    this.membersPayload.searchContent = (this.searchKey || '').trim() || null;
    this.getMemberList();
  }

  admins()
  {
    this.filterName = "Admin";
    this.loadFilteredMembers("ADMIN");
  }

  members(){
    this.filterName = "Members";
    this.loadFilteredMembers("MEMBERS");
  }

  // Admins/Members views use the previous API and hold the full list; search narrows it client-side
  loadFilteredMembers(type: string) {
    this.util.startLoader();
    this.api.query("teams/get/" + this.pathdata.teamId + "?type=" + type).subscribe((res) => {
      if (res) {
        this.membersData = res.data.TeamAdmin.members || [];
        this.membersData.forEach((element) => {
          element.userName = element.firstName + " " + element.lastName;
          element.label_Id = this.pathdata.teamsOwnerId;
        });
        this.totalCount = this.membersData.length;
        this.stopScroll = true;
      }
      this.util.stopLoader();
    }, err => {
      this.util.stopLoader();
    });
  }

  onSearchMember(v: string) {
    this.searchSubject.next(v);
  }

  onScrollDown() {
    if (!this.stopScroll) {
      this.loadScroll = true;
      this.scrollSubject.next(this.previouseAfterKey);
    }
  }

  removeMember(data) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.api
            .delete(
              "teams/delete/member?userId=" +
              data.userId +"&type=REMOVED"+
              "&teamId=" +
              this.pathdata.teamId
            )
            .subscribe((res) => {
              if (res != null) {
                if (this.filterName === 'All') {
                  this.resetPayload();
                  this.getMemberList();
                } else {
                  this.loadFilteredMembers(this.filterName === 'Admin' ? 'ADMIN' : 'MEMBERS');
                }
                this.refresh();
              }
            },err => {
              this.util.stopLoader();
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {

          }
        });

  }


  canShow(data, source) {
    return true;
  }

  connectedlist() {
    this.util.startLoader();
    let queryText:string="teams/member/suggestion?userId=" + localStorage.getItem("userId")+"&orgId=" +this.pathdata.organizationId;

    if(this.pathdata. teamId   !=null && this.pathdata. teamId !=undefined){
      queryText=queryText+ "&teamId=" + this.pathdata.teamId;
    }
    this.api
      .query(
        queryText
      )
      .subscribe((res) => {
        this.util.stopLoader();
        res.data.userDatas.forEach((element) => {
          element.userName = element.firstName + " " + element.lastName;
        });
        this.conditionList = this.sort_by_key(res.data.userDatas, "userName");
      },err => {
        this.util.stopLoader();
      });
  }
  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    }
  }
  resetPayload() {
    this.membersData = [];
    this.membersPayload.searchAfterKey = null;
    this.previouseAfterKey = null;
    this.stopScroll = false;
  }

  getMemberList() {
    this.loadAPIcall = true;
    this.membersPayload.teamId = this.pathdata.teamId;
    const requestSearchContent = this.membersPayload.searchContent;
    this.api.create("teams/findTeamMembers", this.membersPayload).subscribe((res) => {
      this.loadAPIcall = false;
      this.loadScroll = false;
      if (requestSearchContent !== this.membersPayload.searchContent) { return; } // stale: search mode changed mid-flight
      if (res.code === GigsumoConstants.SUCESSCODE) {

        const current = res.data.userDetails || [];
        const searchAfterKey = res.data.searchAfterKey;

        if (current.length === 0 || JSON.stringify(this.previouseAfterKey) === JSON.stringify(searchAfterKey)) {
          this.stopScroll = true;
        }

        current.forEach((element) => {
          element.userName = element.firstName + " " + element.lastName;
          element.label_Id = this.pathdata.teamsOwnerId;
          element.isAdmin = element.isSuperAdmin === true;
        });

        const existingUserIds = new Set(this.membersData.map(member => member.userId));
        const newMembers = current.filter(member => !existingUserIds.has(member.userId));
        this.membersData = [...this.membersData, ...newMembers];

        this.previouseAfterKey = searchAfterKey;
        this.totalCount = res.data.total ?? this.membersData.length;
      }
    }, err => {
      this.loadAPIcall = false;
      this.loadScroll = false;
      this.util.stopLoader();
    });
  }

  handleUserCardEvent(data: any) : void{
    //// console.log(data.event);
   //// console.log('userid - ' + data.data.userId);
   if(data.event != undefined && data.event != null && data.event == 'REMOVE_CONNECTION'){
     this.membersData = this.membersData.filter(element => element.userId != data.data.userId);
   }
 }
  sort_by_key(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  formNetworkModal() {
    this.membersForm = this.fb.group({
      addconnection: this.pathdata.teamName,
      description: this.pathdata.description,
    });
  }

  addmember(template: TemplateRef<any>) {
    this.membersForm.reset();
    this.conditionSelectedItems = [];
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: "static",
      // Unique class on .modal-dialog for the members ng-select's
      // appendTo=".gs-add-members-modal" — panel renders as a sibling of
      // .modal-content (not clipped by overflow) yet inside the fixed dialog
      // (stays glued to its field on scroll). Mirrors gs-transfer-modal.
      class: "gs-add-members-modal",
    });

    this.connectedlist();
  }

  modelhide() {
    // for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
    //   this.modalService.hide(i);
    // }
    this.modalRef.hide()
  }

  submit() {
    this.tempData = [];
    if (
      this.conditionSelectedItems == undefined ||
      this.conditionSelectedItems.length == 0
    ) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please select a member",
        // showConfirmButton: true,
        showConfirmButton: false,
        timer: 2000,
        allowOutsideClick: false,
      });
    } else if (
      this.conditionSelectedItems != undefined &&
      this.conditionSelectedItems.length != 0
    ) {
      if (this.conditionSelectedItems != 0) {
        this.conditionSelectedItems.forEach((element) => {
          this.tempData.push({
            memberUserId: element.userId,
            teamId: this.pathdata.teamId,
          });
        });
      }
      this.util.startLoader();
      this.api.create("teams/members/save", this.tempData).subscribe((res) => {
        this.util.stopLoader();
        this.membersForm.reset();
        if (res != undefined && res != null) {
          if (res.code == "00000") {

            this.modelhide();
            this.refresh();
            this.getInviteList();
            this.connectedlist();

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Invitation sent successfully",
              //showConfirmButton: true,
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2000,
            }).then((result) => {

            });
          } else if (res.code == "99999") {
            this.modelhide();
            this.refresh();
            this.connectedlist();
            this.getInviteList();
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Member add failed",
              text: "Please try again later",
              showConfirmButton: true,
              showCancelButton: false,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
              }
            });
          }
        }
      },err => {
        this.util.stopLoader();

       });
    }
  }
  getInviteList() {
    this.util.startLoader();
    this.api
      .query("teams/member/invites/sent/" + this.pathdata.teamId)
      .subscribe((res) => {
        if (res != undefined && res != null) {
          this.pesponseDisplay.pendingCount=res.data.TeamsMember.length
             this.commonValues.setCommonVariables( this.pesponseDisplay);
         }

      },err => {
        this.util.stopLoader();
      });
    this.util.stopLoader();
  }

  refresh() {
    this.api.query("teams/get/" + this.pathdata.teamId).subscribe((res) => {
      if (res != undefined && res != null) {
        this.commonValues.setTeamdata(res.data.teams)
        this.pesponseDisplay = res.data.teams;
      }
    },err => {
      this.util.stopLoader();
    });
   }


}


